import classNames from "classnames";
import { IconPhone } from "../../../app/components/Icon/Icon.tsx";
import styles from "./LigneEcoute.module.css";

const LigneEcoute = () => {
  return (
    <address className={"col-12 text-center"}>
      <a
        href="tel:+33187023144"
        className={
          "btn btn-primary fw-bold rounded-pill px-5 py-2 text-light m-0 fit-content"
        }
      >
        <p className={classNames("mx-2 m-0 h4", styles.phoneNumber)}>
          <span className={"ms-2"}>01 87 02 31 44</span>&nbsp;
          <IconPhone />
        </p>
        <p className={"fw-light m-0"}>Appel anonyme et gratuit</p>
      </a>
    </address>
  );
};

export default LigneEcoute;
